import Bugsnag from '@bugsnag/js'
import { useQuery } from 'react-query'

import type { Incident } from '@cash-web/protos/squareup/cash/incidentalerts/app/v1/app.pb'
import { IncidentStatus } from '@cash-web/protos/squareup/cash/incidentalerts/app/v1/app.pb'
import { getIncidentsList } from '@cash-web/shared-data-access-api/api'

export const useIncidentAlerts = () => {
  const { data } = useQuery(
    ['incident-alerts'],
    ({ signal }) =>
      getIncidentsList({}, { signal }).then(data => ({
        errorComponents: (data.incidents ?? []).filter(
          (incident: Incident) => incident.status && incident.status !== IncidentStatus.RESOLVED
        ),
      })),
    {
      onError: error => {
        if (error instanceof Error) {
          Bugsnag.notify(error)
        }
      },
    }
  )

  return {
    errorComponents: data?.errorComponents ?? [],
  }
}
